import React from 'react';

import Icon from 'components/shared/Icon/Icon';

import useTiffLoader from '../hooks/useTiffLoader';

import TiffPage from './TiffPage';

const TiffViewer = ({ src, maxHeight, pageBlobs }) => {
  const { pages, loading, error } = useTiffLoader(src, pageBlobs);

  if (loading) {
    return (
      <div className="flex h-full w-full items-center justify-center gap-2 p-3">
        <Icon icon="loader-linear" color="primary" className="animate-spin" />
        <p className="text-sm text-neutral-700">Loading TIFF...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  const viewerStyle = maxHeight
    ? { maxHeight, overflowY: 'auto' }
    : { height: 'auto', overflow: 'visible' };

  return (
    <div className="w-full" style={viewerStyle}>
      <div className="flex flex-col items-center gap-4 p-4">
        {pages.map((page, index) => (
          <TiffPage key={index} page={page} index={index} />
        ))}
      </div>
    </div>
  );
};

export default TiffViewer;
